import { useQuery } from '@tanstack/react-query';

import { CONFIG } from '@constants/config';
import { QUERY_KEYS } from '@constants/query-keys';
import { getRecommendations } from '@services/RecommendationService';

export const useRecommendations = (
  placeId,
  type,
  options = {},
  queryOptions = {
    enabled: true,
    keepPreviousData: true
  }
) => {

  const { refetchInterval } = queryOptions;

  const key = getKey(placeId, type, options, queryOptions);

  return {
    ...useQuery({
      queryKey: key,
      queryFn: () => getRecommendations(placeId, type, options),
      staleTime: CONFIG.DURATIONS.DEFAULT_QUERY_STALE_TIME,
      refetchInterval,
      ...queryOptions
    }),
    key
  };
};

// Helpers

export const getKey = (placeId, type, options, queryOptions) => {

  const { refetchInterval, tokenValue = null } = queryOptions;
  const { isAuthenticated, hash = null } = options;

  return [
    QUERY_KEYS.RECOMMENDATIONS,
    placeId,
    type,
    isAuthenticated,
    refetchInterval,
    tokenValue,
    hash
  ];
};

// Constants

export const RECOMMENDATION_PLACE_IDS = {
  CHECKOUT: 'checkout',
  CART: 'cart',
  SEARCH: 'search'
};

export const RECOMMENDATION_TYPES = {
  EMPTY: null,
  A: 'a'
};
